// src/pages/Login.jsx
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../services/api";
import WelcomeBanner from "../components/WelcomeBanner"; // Importe o componente
import { AuthContext } from "../context/AuthContext";
import "../styles/LoginPage.css";

export default function Login() {
  const navigate = useNavigate();
  const { setUser } = useContext(AuthContext);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    // Carrega e-mail salvo, se existir
    const saved = localStorage.getItem("savedEmail");
    if (saved) {
      setEmail(saved);
      setRememberMe(true);
    }
  }, []);

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      // Ajuste a rota de login conforme seu backend
      const response = await api.post("/api/auth/login", {
        username: email,
        password,
      });
      const token = response.data.token;
      const tokenMenu = response.data.tokenMenu;

      localStorage.clear();

      
      localStorage.setItem("authToken", token);
      localStorage.setItem("tokenMenu", tokenMenu);
      localStorage.setItem("username", email);

      if (rememberMe) {
        localStorage.setItem("savedEmail", email);
      } else {
        localStorage.removeItem("savedEmail");
      }

      setUser({ token });
      navigate("/home");
    } catch (err) {
          alert("Usuário ou senha inválidos \n e ou sem permissão no sistema");
          console.error(err);
          
          // ✅ REMOVIDO: Não force navegação em caso de erro
          // localStorage.clear(); // ✅ Considere manter apenas dados sensíveis
          
          // Limpar apenas campos sensíveis, manter email salvo se necessário
          localStorage.removeItem("authToken");
          localStorage.removeItem("tokenMenu");
          localStorage.removeItem("username");

    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-background_fundo full-height container-fluid d-flex align-items-center justify-content-center">
      <div
        className="row w-100 gx-0 shadow-custom rounded overflow-hidden"
        style={{
          maxWidth: "1200px",
          minHeight: "600px",
          backgroundColor: "rgb(245, 243, 230)",
        }}
      >
        {/* Coluna Esquerda: Formulário */}
        <div className="col-md-4 bg-white p-5 d-flex flex-column justify-content-center">
          <div className="mb-1 text-center">
            <h1 className="h3 fw-bold">Sistema Orçamentário!</h1>
            <p className="text-muted">
              Por favor, insira seus dados de login abaixo
            </p>
          </div>

        {error && (
          <div className="alert alert-danger" role="alert">
            {error}
          </div>
        )}

          <form onSubmit={handleSubmit} className="px-2">
            <div className="mb-3">
              <label htmlFor="inputEmail" className="form-label">
                Usuário
              </label>
              <input
                id="inputEmail"
                type="text"
                className="form-control form-control-lg rounded-pill"
                placeholder="Usuário do Totvs"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className="mb-3 position-relative">
              <label htmlFor="inputPassword" className="form-label">
                Senha
              </label>
              <input
                id="inputPassword"
                type="password"
                className="form-control form-control-lg rounded-pill"
                placeholder="Senha do Totvs"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <i
                className="bi bi-eye-slash-fill position-absolute"
                style={{
                  top: "45px",
                  right: "20px",
                  cursor: "pointer",
                  color: "#6c757d",
                }}
                onClick={() => {
                  const pwdField = document.getElementById("inputPassword");
                  pwdField.type =
                    pwdField.type === "password" ? "text" : "password";
                }}
              ></i>
            </div>

            <div className="d-grid mb-4">
              <button
                type="submit"
                className="btn btn-primary btn-lg rounded-pill"
                disabled={loading}
              >
                {loading ? "Logando..." : "Logar"}
              </button>
            </div>
          </form>
        </div>

        {/* Coluna Direita: Banner de Boas-vindas */}
        <div className="col-md-8 d-none d-md-flex bg-white flex-column justify-content-center align-items-center p-4">
          <WelcomeBanner />
        </div>
      </div>
    </div>
  );
}